<template>
  <f-z-f :title="$t('title.error404')"/>
</template>
<script>
import FZF from "@/components/404.vue";
export default {
  name: 'index',
  components: { FZF},
  data() {
    return {
      
    }
  },
  mounted() {
  },
  methods: {
  }
}

</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/shared/notfind.vue